import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { REFUND_STATUS } from 'domains/customer-order/constants'

const propTypes = {
  status: PropTypes.string
}

/**
 * @param {string} status
 */
const CustomerOrderRefundStatusBadge = ({ status }) => {

  const colorMap = {
    [REFUND_STATUS.NOT_APPLICABLE] : 'primary',
    [REFUND_STATUS.PARTIAL]        : 'info',
    [REFUND_STATUS.FULL]           : 'danger'
  }

  const color = colorMap[status] || 'default'

  return <StatusBadge color={ color } label={ status } />
}

CustomerOrderRefundStatusBadge.propTypes = propTypes

export default CustomerOrderRefundStatusBadge